/**
 * Blox-Design plan page revamp tokens (file rZ4XNmpD7wDFKzIfrkNmhr)
 *
 * Figma frame mapping:
 * - 75644:13794 — Plan toolbar (View Inputs, filter pill, view tabs, What Ifs)
 * - 75644:14192 — Title bar + KPI summary row
 * - 75644:11037 — KPI summary bar (active + inactive metric cards)
 * - 75644:14203 — Builder mode pill
 * - 75644:11968 — Chart section + toolbar
 * - 75644:7652  — Chart card (toolbar, plot, legend)
 * - 75644:12599 — Data table section
 * - 75644:8226  — Data table card (toolbar + grid)
 * - 75644:10724 — Toolbar filter/group pill icons
 * - 75644:10729 — Filter / group-by pill (filter funnel, grip, chevron)
 * - 75911:3707  — Inputs sidebar
 * - 75644:10993 — Inputs left panel (driver list)
 * - 75916:7128  — What-ifs panel open (legacy frame)
 * - 75644:10081  — What Ifs right panel (title, slider, Reset/Save)
 */
export const PLAN_REVAMP_RADIUS = '12px';
export const PLAN_REVAMP_RADIUS_SM = '10px';
export const PLAN_REVAMP_RADIUS_XS = '8px';

export const PLAN_KPI_SELECTED_BG = 'linear-gradient(180deg, #F5F0FF 0%, #FFF 148.91%)';
export const PLAN_KPI_SELECTED_BORDER = '#C4B5FD';
export const PLAN_ACCENT_BLUE = '#3BA7FA';
export const PLAN_BUILDER_MODE_BG = '#121826';
export const PLAN_COMPARE_SCENARIO_DOT = '#008130';

export const PLAN_SEGMENT_TRACK_BG = '#F7F7FB';
export const PLAN_SEGMENT_ACTIVE_SHADOW = '0px 1px 3px rgba(0, 0, 0, 0.08)';

export const PLAN_WHATIFS_PANEL_WIDTH = '283px';
export const PLAN_CHART_VIEW_HEIGHT = '360px';
/** Chart share of viewport in Chart + Table split view */
export const PLAN_CHART_SPLIT_VIEW_RATIO = '70%';
/** Minimum table share in Chart + Table split view */
export const PLAN_TABLE_SPLIT_VIEW_RATIO = '30%';
/** @deprecated Use ratio-based split layout in chart-table view */
export const PLAN_CHART_SPLIT_VIEW_HEIGHT = '300px';
export const PLAN_MAIN_CONTENT_GAP = '12px';
/** Figma desktop page inset — 72px (Chakra spacing 18 × 4px) */
export const PLAN_HEADER_HORIZONTAL_PADDING = 18;
export const PLAN_TOOLBAR_HEIGHT = '48px';
export const PLAN_TOOLBAR_ARROW_TAB_HEIGHT = 32;
export const PLAN_TOOLBAR_ARROW_TAB_WIDTH = 96;
export const PLAN_FILTER_PILL_HEIGHT = '32px';
/** Figma Red (alert) */
export const PLAN_FILTER_BADGE_BG = '#FE552F';

export const PLAN_TABLE_TOOLBAR_HEIGHT = '40px';
export const PLAN_TABLE_TIME_TOGGLE_SIZE = '28px';
export const PLAN_TABLE_TIME_TOGGLE_RADIUS = '8px';
export const PLAN_TABLE_CELL_BORDER = '#E8E9EB';
export const PLAN_TABLE_METRIC_COLUMN_MIN_WIDTH = '211px';

export const PLAN_CHART_CARD_RADIUS = '16px';
/** Figma chart series palette (75644:7652) */
export const PLAN_CHART_SERIES_COLORS = [
  '#8B5CF6',
  '#11CDDA',
  '#22C55E',
  '#FE552F',
  '#3BA7FA',
] as const;

export { PLAN_FONT, PLAN_TEXT } from './planPageRevampTypography';
export type { PlanTextVariant } from './planPageRevampTypography';
